import React, { useState, useEffect } from 'react';
import {config} from "../../shared/config.js";
import * as util from '../../shared/commons.js';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../../shared/ShowError.jsx';
import Laoding from '../../shared/Laoding.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import ClientCombo from '../../combos/ClientCombo.jsx';
import ProductCombo from '../../combos/ProductCombo.jsx';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../../shared/GeneralDialogFooter.jsx';
import ShowConfirm from '../../shared/ShowConfirm.jsx';
import Table from 'react-bootstrap/Table';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import { InputText } from 'primereact/inputtext';
import CityCombo from '../../combos/CityCombo.jsx';
import { FloatLabel } from 'primereact/floatlabel';
import FaDate from '../../shared/FaDate.jsx';
import { InputNumber } from 'primereact/inputnumber';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PrintContraxtBill from '../../prints/PrintContraxtBill.jsx';
import { InputTextarea } from 'primereact/inputtextarea';
import ServiceCombo from '../../combos/ServiceCombo.jsx';
import IpgTransactionStateCombo from '../../combos/IpgTransactionStateCombo.jsx';

var editedModules = [];
var editedParameters = {};
export default function IpgTransactionList(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [searching, setSearching] = useState(false);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [ipgTransaction, setIpgTransaction] = useState([]);
    const [ipgTransactions, setIpgTransactions] = useState([]);
    const [ipgTransactionIndex, srtIpgTransactionIndex] = useState(-1);
    const [buyNo, setBuyNo] = useState(0);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [confirmDeleteErrorsVisible, setConfirmDeleteErrorsVisible] = useState(false);
    const [confirmChangeStateVisible, setConfirmChangeStateVisible] = useState(false);
    const [searchPanelVisible, setSearchPanelVisible] = useState(false);
    const [searchOptions, setSearchOptions] = useState({client:null, mobile:"", fromAmount:0, toAmount:0, fromDate:0, toDate:0, searchText:"", transactionState:null});
    const [buyService, setBuyService] = useState(null);
    const [fromDate, setFromDate] = useState(0);
    const [newFromDate, setNewFromDate] = useState(0);
    const [toDate, setToDate] = useState(0);
    const [newToDate, setNewToDate] = useState(0);

    useEffect(() => {
        loadItems(true);
    }, []);

    const loadItems = function(isFirst){
        if(isFirst)setLoading(true);
        else setSearching(true);
        var userId = "";
        var mobile = "";
        var transactionStateId = 0;
        var fromAmount = true;
        var toAmount = true;
        var searchText = "";
        var fromDate = 0;
        var toDate = 0;
        if(searchOptions != null){
            if(searchOptions.client != null)userId = searchOptions.client.id;
            searchOptions.fromDate = newFromDate;
            searchOptions.toDate = newToDate;
            mobile = searchOptions.mobile;
            fromAmount = searchOptions.fromAmount;
            toAmount = searchOptions.toAmount;
            searchText = searchOptions.searchText;
            if(searchOptions.transactionState != null)transactionStateId = searchOptions.transactionState.id;
            fromDate = searchOptions.fromDate;
            toDate = searchOptions.toDate;
        }
        var params = {
            login:util.getLoginDto(), 
            userId:userId,
            mobile:mobile,
            transactionState:transactionStateId,
            fromAmount:fromAmount,
            toAmount:toAmount,
            searchText:searchText,
            fromDate:fromDate,
            toDate:toDate,
        };
        var url = config.Server+`/payment/ipg-transactions/list`;
        console.log("params in ipg-transactions/list is>", params);
        console.log("url in ipg-transactions/list is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("setIpgTransactions is> ", response);
                setIpgTransactions(response);
                if(isFirst)setLoading(false);
                else setSearching(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                if(isFirst)setLoading(false);
                else setSearching(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
                if(isFirst)setLoading(false);
                else setSearching(false);
        });

    }
    const onRowDeleteClick = function(c, cInd){
        setIpgTransaction(c);
        srtIpgTransactionIndex(cInd);
        setConfirmDeleteVisible(true);
    }
    const onRowChangeStateClick = function(c, cInd){
        return;
        setBuyService(c);
        srtIpgTransactionIndex(cInd);
        setConfirmChangeStateVisible(true);
    }
    const setRowActions = function (row, cInd) {
        return (
        <Row className="justify-content-md-center" style={{}}>
            {/* <Button icon="pi pi-check" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowChangeStateClick(row, cInd)} title="تائید" /> */}
            <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowDeleteClick(row, cInd)} title="حذف" />
        </Row>
        );
    }
    //=====================================================================================================================================
    //============                  delete single transaction       =======================================================================
    //=====================================================================================================================================
    const deleteItem = function(){
        setDeleting(true);
        var transactionIds = [];
        transactionIds.push(ipgTransaction.id);
        var params = {login:util.getLoginDto(), transactionIds:transactionIds};
        var url = config.Server+`/payment/ipg-transactions/set-as-deleted`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...ipgTransactions];
                ncs.splice(ipgTransactionIndex, 1);
                setIpgTransactions(ncs);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }
    //=====================================================================================================================================
    //============                  delete errors transaction       =======================================================================
    //=====================================================================================================================================
    const onDeleteErrorsClicked = function(){
        setConfirmDeleteErrorsVisible(true);
    }
    const deleteErrorItems = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto()};
        var url = config.Server+`/payment/ipg-transactions/all/set-as-deleted`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                setDeleting(false);
                setConfirmDeleteErrorsVisible(false);
                loadItems(true);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteErrorsConfirm_Accept = function(){
      deleteErrorItems();
    }
    const onDeleteErrorsConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteErrorsVisible(false);
    }
    //=====================================================================================================================================
    const changeStateItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:buyService.id};
        var url = config.Server+`/contract/buy-service/change/state`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...ipgTransactions];
                ncs[ipgTransactionIndex] = {...response.data};
                setIpgTransactions(ncs);
                console.log("ncs is>", ncs)

                setDeleting(false);
                setConfirmChangeStateVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onChangeStateConfirm_Accept = function(){
      changeStateItem();
    }
    const onChangeStateConfirm_Reject = function(){
        if(deleting) return;
        setConfirmChangeStateVisible(false);
    }
    const onSearchInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        var so = {...searchOptions};
        if((name === "searchText")) so[name] = val;
        else if((name == "fromAmount")||(name == "toAmount")){
            if(val == "") val = "0";
            so[name] = parseInt(val);
        }
        setSearchOptions(so);
    }
    const onSearchIpgTransactionStateSelected = function(value){
        console.log("selected IpgTransactionState is>", value)
        var so = {...searchOptions};
        if(value){
            so["transactionState"] = value;
        }
        else{
            so["transactionState"] = null;
        }
        setSearchOptions(so);
        
    }
    const onSearchClientSelected = function(value){
        console.log("selected product is>", value)
        var so = {...searchOptions};
        if(value){
            so["client"] = value;
        }
        else{
            so["client"] = null;
        }
        setSearchOptions(so);
        
    }
    const setRowState = function (row, cInd) {
        var color = "#1ea01eff";
        var text = "تائید شده";
        if(row.ipgTransactionState.id != util.IpgTransactionStates.Accepted){
            color = "#ff0000";
            text = "خطا";
        }
        return(
            <>
                <div style={{display:"inline-block", width:"16px", height:"16px", borderRadius:"50%", backgroundColor:color}}></div>
                <label style={{color:color}}>&nbsp;{text}</label>
            </>
        )
    }
    const setRowTarget = function (row, cInd) {
        var text = row.afterPaymentTarget.transactionType.title;
        if(row.afterPaymentTarget.companyDetail != null)text += ", " + row.afterPaymentTarget.companyDetail.title;
        return(
            <>
                <label style={{}}>&nbsp;{text}</label>
            </>
        )
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست تراکنش ها..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            
            
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست تراکنش های اینترنتی
            </div>
            {
              searchPanelVisible?
              <Row style={{border:"1px dashed #b0b0b0", padding:"5px", margin:"10px 0px 0px 0px"}}>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <FaDate value={fromDate} onChange={(val)=>setNewFromDate(val)} />
                        <label htmlFor="fromDate">از تاریخ</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <FaDate value={toDate} onChange={(val)=>setNewToDate(val)} />
                        <label htmlFor="toDate">تا تاریخ</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.fromAmount} onChange={(e)=>{onSearchInputChange(e, "fromAmount")}} id="fromAmount" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={15} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="fromAmount">از مبلغ</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.toAmount} onChange={(e)=>{onSearchInputChange(e, "toAmount")}} id="toAmount" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={15} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="toAmount">تا مبلغ</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"0px"}}>
                    <ClientCombo onChange={(val)=>{onSearchClientSelected(val)}} value={searchOptions.client} includeAdmins={false} includeAssistants={false} includeAgents={true} includeClients={true}/>
                </Col>
                <Col md={3} style={{marginTop:"0px"}}>                
                    <IpgTransactionStateCombo onChange={(val)=>{onSearchIpgTransactionStateSelected(val);}} value={searchOptions.transactionState} />
                </Col>
                <Col md={12} style={{marginTop:"30px"}}>
                    <Button label="&nbsp;&nbsp;  جستجو کن  &nbsp;&nbsp;" icon="pi pi-search" loading={searching} onClick={()=>loadItems(false)} severity="primary" iconPos="right" style={{borderRadius:"5px"}} />
                </Col>
              </Row>
              :<></>
            }
              <Row style={{}}>
                <Col xs={12} md={3}>
                    <table style={{width:"100%"}}>
                        <tbody>
                        <tr>
                            <td style={{padding:"5px"}}><Button label="" icon="pi pi-search" onClick={()=>setSearchPanelVisible(!searchPanelVisible)} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                            <td style={{padding:"5px", direction:"ltr"}}><Button label="حذف تراکنش های خطا دار" icon="pi pi-trash" onClick={()=>onDeleteErrorsClicked()} severity="danger" iconPos="right" style={{borderRadius:"5px"}} /></td>
                        </tr>
                        </tbody>
                    </table>
                </Col>
              </Row>


              <DataTable value={ipgTransactions} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id">
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="buyService.id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="transactionNo" header={"شماره"} body={(row) => (util.toPersianDigits(row.transactionNo) )} sortable className="list-cell-text-align"></Column>
                <Column field="transactionDate" header={"تاریخ"} body={(row, options) => (util.toPersianDigits(util.SeperateDate(row.transactionDate)) )} sortable className="list-cell-text-align"></Column>
                <Column field="transactionTime" header={"زمان"} body={(row, options) => (util.toPersianDigits(util.SeperateTime(row.transactionTime)) )} sortable className="list-cell-text-align"></Column>
                <Column field="user.lastname" body={(row) => (row.user.mobile + " " + row.user.firstname + " " + row.user.lastname)} header={"مشتری"} sortable className="list-cell-text-align"></Column>
                <Column field="amount" header={"مبلغ"} body={(row, options) => (util.toPersianDigits(util.SeperatePrice(row.amount-row.tax)) )} sortable className="list-cell-text-align"></Column>
                <Column field="tax" header={"ارزش افزوده"} body={(row, options) => (util.toPersianDigits(util.SeperatePrice(row.tax)) )} sortable className="list-cell-text-align"></Column>
                <Column field="amount" header={"جمع کل"} body={(row, options) => (util.toPersianDigits(util.SeperatePrice(row.amount)) )} sortable className="list-cell-text-align"></Column>
                <Column field="afterPaymentTarget.transactionType.title" header={"هدف"} body={(row, options) => setRowTarget(row, options.rowIndex)} sortable className="list-cell-text-align"></Column>
                <Column field="ipgTransactionState" header={"وضعیت"} body={(row, options) => setRowState(row, options.rowIndex)} sortable className="list-cell-text-align"></Column>
                <Column field="referenceNo" header={"شناسه ارجاع'"} sortable className="list-cell-text-align"></Column>
                <Column body={(row, options) => setRowActions(row, options.rowIndex)} exportable={false} style={{ }}></Column>
              </DataTable>


            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
            <ShowConfirm visible={confirmDeleteErrorsVisible} message="آیا از حذف موارد دارای خطا مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteErrorsConfirm_Accept} onReject={onDeleteErrorsConfirm_Reject} loading={deleting} />
            <ShowConfirm visible={confirmChangeStateVisible} message="آیا از تغیر وضعیت مطمئن هستید؟" caption="اطمینان از تغیر وضعیت" onAccept={onChangeStateConfirm_Accept} onReject={onChangeStateConfirm_Reject} loading={deleting} />
        </>
    )
}